var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowPrev({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 9.674,
    viewBox: "0 0 10 9.674",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "arrow-prev",
    d: "M253.265,247.976h-7.949l4.758-4.13a.108.108,0,0,0-.071-.19h-1.2a.218.218,0,0,0-.143.053l-5.134,4.455a.437.437,0,0,0-.15.328.432.432,0,0,0,.039.18.426.426,0,0,0,.11.148l5.164,4.482a.108.108,0,0,0,.071.027H250a.108.108,0,0,0,.071-.19l-4.756-4.13h7.949a.11.11,0,0,0,.109-.109v-.815A.11.11,0,0,0,253.265,247.976Z",
    transform: "translate(-243.374 -243.656)",
    fill: "#33af89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowPrev);
export default __webpack_public_path__ + "static/media/arrow-prev.83c829d562d39ec1f05ddeaa67bd452e.svg";
export { ForwardRef as ReactComponent };